import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzActionErrorWebComponent } from './component/GzActionErrorWebComponent';
import { ErrorRenderData } from '../../types';

export class ActionErrorPopUp extends NetworkBasePopUp<GzActionErrorWebComponent, ErrorRenderData> {
  protected transformToTaskTarget = false;
  protected title;
  protected extraDialogConfigs = {
    isWindow: false,
  };
  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {}

  protected customSetup() {
    if (!this.data.specifics) {
      throw new Error('Error render data missing.');
    }

    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        hidden: true,
      },
      {
        id: 'closeButton',
        label: this.data.specifics.buttonText,
      },
    ];

    this.title = this.data.specifics.title;
    this.popUpContent = new GzActionErrorWebComponent();
    this.popUpContent.errorMessages = this.data.specifics.errorMessages;
    if (this.data.specifics.textOffsetTop) {
      this.popUpContent.textOffsetTop = this.data.specifics.textOffsetTop;
    }
  }
}
